/** Selectable gaps in weeks between plans in a series. Zero means consecutive weeks. */
export const WEEKS_BETWEEN_PLANS_OPTIONS = [0, 1, 2, 3, 4, 5];

/** Gap the dialog opens on: consecutive weeks, the case that had no option before. */
export const DEFAULT_WEEKS_BETWEEN_PLANS = 0;

/** A single plan needs no gap, so the gap field only appears beyond this count. */
export const MIN_PLAN_COUNT_FOR_GAP = 2;

/** Summary sentence per wording variant returned by `buildTreatmentPlanRolloutSummary`. */
export const ROLLOUT_SUMMARY_KEYS = {
  single: 'add-treatment-plan-batch-summary-single',
  consecutive: 'add-treatment-plan-batch-summary-consecutive',
  gapOne: 'add-treatment-plan-batch-summary-gap-one',
  gap: 'add-treatment-plan-batch-summary-gap'
} as const;
